import { FC } from 'react';
import {
  StyledSelect,
  InputWrapper,
  InputWithoutPaddingWrapper,
} from 'containers/CourtManagerAssignedExpertise/style';
import { Input, InputLabel, MenuItem } from '@material-ui/core';

interface SelectElementProps {
  label: string;
  value: string;
  multiple: boolean;
  withoutPadding?: boolean;
}

const SelectElement: FC<SelectElementProps> = props => {
  const { label, value } = props;
  return props.withoutPadding ? (
    <InputWithoutPaddingWrapper>
      <InputLabel>{label}</InputLabel>
      {props.multiple ? (
        <StyledSelect
          fullWidth
          label="Age"
          input={<Input />}
          disabled
          value={value}
          multiple={props.multiple}
          renderValue={
            /* istanbul ignore next */ (value: any) =>
              /* istanbul ignore next */ (
                value &&
                ((value as any).map((element: any) => element.title) as any)
              ).join(', ')
          }
        ></StyledSelect>
      ) : (
        <StyledSelect
          fullWidth
          label="Age"
          defaultValue={1}
          input={<Input />}
          disabled
        >
          <MenuItem value={1}>{value}</MenuItem>
        </StyledSelect>
      )}
    </InputWithoutPaddingWrapper>
  ) : (
    <InputWrapper>
      <InputLabel>{label}</InputLabel>
      {props.multiple ? (
        <StyledSelect
          fullWidth
          label="Age"
          input={<Input />}
          disabled
          value={value}
          multiple={props.multiple}
          renderValue={
            /* istanbul ignore next */ (value: any) =>
              /* istanbul ignore next */ (
                value &&
                ((value as any).map((element: any) => element.title) as any)
              ).join(', ')
          }
        ></StyledSelect>
      ) : (
        <StyledSelect
          fullWidth
          label="Age"
          defaultValue={1}
          input={<Input />}
          disabled
        >
          <MenuItem value={1}>{value}</MenuItem>
        </StyledSelect>
      )}
    </InputWrapper>
  );
};

export default SelectElement;
